"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardText = exports.TitleWrapper = exports.CardDescription = exports.CardHeader = exports.ContentCardWrapper = exports.ClosedCardWrapper = exports.CardWrapper = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.CardWrapper = native_1.default.View ``;
exports.ClosedCardWrapper = native_1.default.TouchableOpacity `
  width: 100%;
  padding: 24px;
  border-bottom-color: rgba(0, 0, 0, 0.1);
  border-bottom-width: ${({ border = true }) => (border ? '1px' : '0px')};
  border-top-color: rgba(0, 0, 0, 0.1);
  border-top-width: 1px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
exports.ContentCardWrapper = native_1.default.View `
  background-color: #fff;
  height: auto;
  padding-horizontal: 24px;
  border-bottom-color: rgba(0, 0, 0, 0.1);
  border-bottom-width: ${({ border = false }) => (border ? '1px' : '0px')};
`;
exports.CardHeader = native_1.default.Text `
  padding-top: 20px;
  font-weight: 600;
  font-family: Roboto-Regular;
  font-size: 16px;
  line-height: 24px;
`;
exports.CardDescription = native_1.default.Text `
  padding-top: 20px;
  padding-bottom: 25px;
  color: rgba(17, 17, 17, 0.8);
  font-family: Roboto-Regular;
  font-size: 14px;
  line-height: 23px;
  text-align: left;
`;
exports.TitleWrapper = native_1.default.View `
  flex-direction: row;
  align-items: center;
`;
exports.CardText = native_1.default.Text `
  padding-left: 12px;
  font-family: Roboto-Regular;
  font-size: 16px;
  letter-spacing: 0.7px;
`;
